// Dependencias
import DataTable, { Api } from 'datatables.net-bs5';
import { format } from '@formkit/tempo';

// Utils
import {
  ValidationsTypes,
  validInputStyle,
  validationInputs
} from '../utils/stylesInputs';
import {
  drawPlanElement,
  drawStatusElement,
  drawTable,
  formatPhoneNumber,
  drawYesNoElement
} from '../utils/drawTable';
import { loadLoader } from '../utils/loader';

// Configuraciones
import { generalConfig } from '../config/datatable.config';

// Services
import * as clientService from '../service/client.service';

// Elementos HTML
const formSearchElement = document.querySelector<HTMLFormElement>('#form-search')!;
const selectSearchElement = document.querySelector<HTMLSelectElement>('#selectSearch')!;
const inputSearchElement = document.querySelector<HTMLInputElement>('#inputSearch')!;
const tableUsersElement = document.querySelector<HTMLTableElement>('#users-list')!;
const btnExportExcel = document.querySelector<HTMLButtonElement>('#exportExcel')!;

// Variables globales
let clientsTable: Api<string[]>;
let currentPage = 1;
let lengthTable = 10;
const eventsInputsToValid = ['keyup', 'change', 'focusout'];

export function main() {
  document.addEventListener('DOMContentLoaded', () => {
    // Se inicializa la tabla de Clientes
    clientsTable = new DataTable(tableUsersElement, generalConfig);

    clientsTable.on('draw', async() => {
      const info = clientsTable.page.info();

      // Si la Pagina no es mayor a los datos establecidos, sale de la función
      if (!(info.page + 1 > currentPage)) return;

      // Optengo los datos de los filtros
      const json = Object.fromEntries(
        new FormData(formSearchElement)
      ) as ParamsSearch;
      currentPage = info.page + 1;

      loadLoader({});
      const addListOfClients = await clientService.searchClientsBy({
        params: {
          [json.selectSearch]: json.valueToSearch
        },
        page: currentPage + 1,
        limit: lengthTable
      });
      drawTable({
        data: addListOfClients,
        table: clientsTable,
        addFinale: true,
        format: formatClients
      });
      loadLoader({ start: false });
    });

    // Cambio de tamaño de la tabla
    clientsTable.on('length', async(_, __, len) =>  {
      lengthTable = len;
      // Optengo los datos de los filtros
      const json = Object.fromEntries(
        new FormData(formSearchElement)
      ) as ParamsSearch;

      loadLoader({});
      const addListOfClients = await clientService.searchClientsBy({
        params: {
          [json.selectSearch]: json.valueToSearch
        },
        limit: lengthTable * 2
      });
      drawTable({
        data: addListOfClients,
        table: clientsTable,
        format: formatClients
      });
      currentPage = 1;
      loadLoader({ start: false });
    });
  });

  // Eventos de Validacion de inputs
  selectSearchElement.addEventListener('change', async() => {
    // Se realizan procesos en paralero, para evitar el uso de 2 eventos del mismo tipo
    await Promise.all([
      // Proceso para ejecutar si la opción elejida por el input es correcta
      (() => {
        // Optencion de los elementos del input
        const container = selectSearchElement.parentElement as HTMLDivElement;
        const input = selectSearchElement;

        validInputStyle({
          type: ValidationsTypes.VALID,
          container,
          input
        });
      })(),
      // Proceso para cambir el input de opcion o cambio de elemento HTML
      (() => {
        // Se optienen los elementos HTML del DOM Actual
        const inputToChange = formSearchElement.querySelector('input')!;
        const [, divElementContainer] = formSearchElement.children;

        // Se valida que la opción elejida del input sea por: Text, phone y Email
        const currentOptionType = selectSearchElement.value as TypeInputOptions;
        const isVerifyOption = TypeInputOptions.VERIFIY === currentOptionType;

        if (!isVerifyOption) {
          // Si se encuntra el Input no se debe de eliminar, solo se habilita la busqueda
          if (inputToChange) {
            const isAllOption = currentOptionType === TypeInputOptions.ALL;
            inputToChange.value = isAllOption ? '' : inputToChange.value;
            inputToChange.classList.remove('is-invalid', 'is-valid');
            inputToChange.disabled = isAllOption;
            return;
          }

          // Se crea el input si Existe el Select para cambio de datos
          const createdInput = document.createElement('input');
          createdInput.required = true;
          createdInput.type = 'text';
          createdInput.name = 'valueToSearch';
          createdInput.placeholder = 'Buscar';
          createdInput.classList.add('form-control', 'text-black-50');

          // Se agrega el evento de validacion de inputs
          eventsInputsToValid.forEach((event) =>
            createdInput.addEventListener(event, (e) =>
              validationInputs({ e })
            )
          );

          // Se remueve el elmento y se añada al contenedor
          formSearchElement.querySelector('#inputSearch')!.remove();
          divElementContainer.appendChild(createdInput);

          // Si elije la opcion de Todos los usuarios se desabilita el input
          createdInput.disabled = currentOptionType === TypeInputOptions.ALL;

          return;
        }

        // Se elige el input
        let isFirstElement = true;
        // Se crean el Select Correspondiente en el tablero
        const selectInput = document.createElement('select');
        const optionsElements = [
          'Seleccione una opción',
          'hr',
          'Verificado',
          'Rechazado'
        ].map((value, index) => {
          if (value === 'hr') return document.createElement('hr');
          const option = document.createElement('option');
          if (isFirstElement) {
            option.value = '';
            option.disabled = true;
            option.selected = true;
            isFirstElement = false;
          }
          if ([3, 2].includes(index))
            option.value =
              index === 2
                ? clientService.StatusUsers.VERIFICADO
                : clientService.StatusUsers.SIN_VERIFICAR;
          option.text = value;
          return option;
        });
        selectInput.id = 'inputSearch';
        selectInput.append(...optionsElements);
        selectInput.classList.add('form-select', 'text-black-50');
        selectInput.name = 'valueToSearch';
        selectInput.required = true;

        // Se agrega el evento de validacion de inputs
        eventsInputsToValid.forEach((event) =>
          selectInput.addEventListener(event, (e) => validationInputs({ e }))
        );

        // Se remueve el elmento y se añada al contenedor
        formSearchElement.querySelector('input')!.remove();

        divElementContainer.appendChild(selectInput);
      })()
    ]);
  });

  // Configuración de eventos para los inputs
  eventsInputsToValid.forEach((event) =>
    inputSearchElement.addEventListener(event, (e) => validationInputs({ e }))
  );

  // Formulario para busqieda de información
  formSearchElement.addEventListener('submit', async(e) => {
    e.preventDefault();

    // Se optiene la información del formulario
    const target = e.target as HTMLFormElement;
    const json = Object.fromEntries(new FormData(target)) as ParamsSearch;

    // Se aplica al Loader de la aplicación
    loadLoader({});

    // Se realiza la optencion de valores para el servicio
    currentPage = 1;
    const listOfClients = await clientService.searchClientsBy({
      params: {
        [json.selectSearch]: json.valueToSearch
      },
      limit: 20
    });
    drawTable({
      table: clientsTable,
      data: listOfClients,
      format: formatClients
    });

    loadLoader({ start: false });
  });

  // funcionalidad de exportación de Excel
  btnExportExcel.addEventListener('click', async() => {
    const json = Object.fromEntries(
      new FormData(formSearchElement)
    ) as ParamsSearch;

    loadLoader({});
    const file = await clientService.searchClientsBy({
      exporting: true,
      params: {
        [json.selectSearch]: json.valueToSearch
      }
    });
    const url = URL.createObjectURL(new Blob([file]));
    const link = document.createElement('a');

    link.href = url;
    link.setAttribute('download', 'signly-erp.xlsx');
    link.click();
    loadLoader({ start: false });
  });
}

/**
 *
 * @param data
 * @returns
 */
const formatClients = (data: clientService.Client[]) =>
  data.map((client) =>
    Object.values({
      id: `${client.id}`,
      fullname: `${client.fullName}`,
      email: `${client.email}`,
      phone: formatPhoneNumber(client.phone),
      plan: drawPlanElement(client.plan),
      status: drawStatusElement(client.status),
      whmcsOrderId: client.whmcsOrderId ? client.whmcsOrderId : 'N/A',
      lastPurchaseDate: client.lastPurchaseDate
        ? format({
            date: client.lastPurchaseDate,
            format: 'full',
            locale: 'es'
          })
        : 'N/A',
      hasSignedAsGuest: drawYesNoElement(client.hasSignedAsGuest),
      hasSignedDocuments: drawYesNoElement(client.hasSignedDocuments),
      hasUploadedDocuments: drawYesNoElement(client.hasUploadedDocuments)
    })
  );

// Definicion de tipos e interfaces
type ParamsSearch = {
  selectSearch: string;
  valueToSearch: string;
};
/**
 * Enumeración de opciones para el input de busqueda
 */
enum TypeInputOptions {
  ALL = 'all',
  ID = 'id',
  NAME = 'name',
  EMAIL = 'email',
  VERIFIY = 'status',
}
